export const extractJsonFromText = (text) => {
    if (!text) return '{}';

    // First try to match triple backticks block
    const jsonMatch = text.match(/```(?:json)?\s*([\s\S]*?)\s*```/i);
    if (jsonMatch) {
        return jsonMatch[1].trim();
    }

    // Then try to match any JSON object or array structure
    const looseMatch = text.match(/(\{[\s\S]*\}|\[[\s\S]*\])/);
    if (looseMatch) {
         return looseMatch[0].trim();
    }

    // Fallback: strip backticks and json keywords
    return text.replace(/```json/gi, '').replace(/```/g, '').replace(/`/g, '').trim();
};
